import React from 'react';
import { Tag } from '../../types';
import Badge from '../common/Badge';

interface TagFilterProps {
  tags: Tag[];
  selectedTags: string[];
  onToggleTag: (tagName: string) => void;
  loading?: boolean;
  maxVisible?: number;
}

const TagFilter: React.FC<TagFilterProps> = ({
  tags,
  selectedTags,
  onToggleTag,
  loading = false,
  maxVisible = 10,
}) => {
  const [showAll, setShowAll] = React.useState(false);

  if (loading) {
    return (
      <div className="animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-16 mb-3"></div>
        <div className="flex flex-wrap gap-2">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-6 bg-gray-200 rounded-full w-16"></div>
          ))}
        </div>
      </div>
    );
  }

  const visibleTags = showAll ? tags : tags.slice(0, maxVisible);
  const hasMore = tags.length > maxVisible;

  return (
    <div>
      <h3 className="text-sm font-medium text-gray-900 mb-3">태그</h3>
      
      <div className="flex flex-wrap gap-2 mb-2">
        {visibleTags.map((tag) => {
          const isSelected = selectedTags.includes(tag.name);
          
          return (
            <button
              key={tag.id}
              onClick={() => onToggleTag(tag.name)}
              className={`
                inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium
                transition-colors duration-200
                ${isSelected
                  ? 'bg-primary-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }
              `}
              style={{
                backgroundColor: isSelected ? tag.color : undefined,
              }}
            >
              {tag.name}
              {tag.prompt_count !== undefined && (
                <span className={`ml-1 ${isSelected ? 'text-white' : 'text-gray-500'}`}>
                  ({tag.prompt_count})
                </span>
              )}
            </button>
          );
        })}
      </div>

      {hasMore && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="text-xs text-primary-600 hover:text-primary-700 font-medium"
        >
          {showAll ? '접기' : `+${tags.length - maxVisible}개 더보기`}
        </button>
      )}

      {selectedTags.length > 0 && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">
              선택된 태그 ({selectedTags.length})
            </span>
            <button
              onClick={() => selectedTags.forEach(tag => onToggleTag(tag))}
              className="text-xs text-red-600 hover:text-red-700"
            >
              모두 해제
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TagFilter;